/* En-tête et menu Coiffissimo (remplace Buddha Mega Menu) */
(function () {
  var root = document.querySelector('[data-ccm]');
  if (!root) return;
  var section = root.closest('.shopify-section') || root;
  var veil = root.querySelector('[data-ccm-veil]');
  var burger = root.querySelector('[data-ccm-open]');
  var desk = window.matchMedia('(min-width: 990px)');
  var items = [].slice.call(root.querySelectorAll('.ccm-li'));
  var openT, closeT;
  function T() { try { (window.__ccq = window.__ccq || []).push([].slice.call(arguments)); } catch (e) {} }

  /* ---------- panneaux ---------- */
  function current() { return root.querySelector('.ccm-li.is-open'); }
  function setOpen(li) {
    if (li && li !== current()) T('menu', 'ouverture', (li.querySelector('.ccm-tl-t, .ccm-tl') || li).textContent, { zone: desk.matches ? 'ordinateur' : 'mobile' });
    items.forEach(function (x) {
      var on = x === li;
      x.classList.toggle('is-open', on);
      var b = x.querySelector(':scope > .ccm-tl');
      if (b && b.tagName === 'BUTTON') b.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
    if (desk.matches) veil.hidden = !li;
    active();
  }
  function active() {
    section.classList.toggle('ccm-active', !!current() || document.documentElement.classList.contains('ccm-open'));
  }
  function closeAll() { clearTimeout(openT); clearTimeout(closeT); setOpen(null); }

  items.forEach(function (li) {
    var btn = li.querySelector(':scope > .ccm-tl');
    if (!btn) return;
    li.addEventListener('mouseenter', function () {
      if (!desk.matches || document.documentElement.classList.contains('ccs-on')) return;
      clearTimeout(closeT); clearTimeout(openT);
      if (btn.tagName !== 'BUTTON') { closeT = setTimeout(closeAll, 120); return; }
      openT = setTimeout(function () { setOpen(li); }, current() ? 0 : 110);
    });
    if (btn.tagName !== 'BUTTON') return;
    btn.addEventListener('click', function () {
      clearTimeout(openT);
      setOpen(li.classList.contains('is-open') && desk.matches ? null : li);
      if (!desk.matches) { var p = li.querySelector('.ccm-panel'); if (p) p.scrollTop = 0; }
    });
  });
  root.querySelector('.ccm-nav').addEventListener('mouseleave', function () {
    if (!desk.matches) return;
    clearTimeout(openT);
    closeT = setTimeout(closeAll, 220);
  });
  root.querySelector('.ccm-nav').addEventListener('mouseenter', function () { clearTimeout(closeT); });
  veil.addEventListener('click', closeAll);
  veil.addEventListener('mouseenter', function () { closeT = setTimeout(closeAll, 120); });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var pane = root.querySelector('.ccm-pane.is-m');
    if (pane) pane.classList.remove('is-m');
    else if (current()) closeAll();
    else if (document.documentElement.classList.contains('ccm-open')) drawer(false);
  });

  /* ---------- tiroir mobile ---------- */
  function drawer(on) {
    document.documentElement.classList.toggle('ccm-open', on);
    burger.setAttribute('aria-expanded', on ? 'true' : 'false');
    active();
    if (!on) { closeAll(); root.querySelectorAll('.ccm-pane.is-m').forEach(function (p) { p.classList.remove('is-m'); }); }
  }
  burger.addEventListener('click', function () { drawer(true); T('menu', 'tiroir_ouvert'); });
  root.querySelector('[data-ccm-close]').addEventListener('click', function () { drawer(false); });
  root.querySelectorAll('[data-ccm-back]').forEach(function (b) { b.addEventListener('click', function () { setOpen(null); }); });
  root.querySelectorAll('[data-ccm-tabback]').forEach(function (b) { b.addEventListener('click', function () { b.closest('.ccm-pane').classList.remove('is-m'); }); });
  desk.addEventListener('change', function () { drawer(false); });

  /* ---------- onglets ---------- */
  // Menu mobile : les produits du menu les plus commandés sur 7 jours, en tête du tiroir.
  var reco = root.querySelector('[data-ccm-reco]');
  if (reco) {
    var rseen = {}, rcards = [];
    root.querySelectorAll('.ccm-top .ccm-card').forEach(function (c) {
      if (rseen[c.dataset.pid] || !(+c.dataset.s)) return;
      rseen[c.dataset.pid] = 1; rcards.push(c);
    });
    rcards.sort(function (a, b) { return (+b.dataset.s || 0) - (+a.dataset.s || 0); });
    var rail = reco.querySelector('.ccm-reco-rail');
    rcards.slice(0, 10).forEach(function (c) {
      var k = c.cloneNode(true);
      k.className = 'ccm-card';
      var im = k.querySelector('img'); if (im) { im.removeAttribute('loading'); im.setAttribute('sizes', '116px'); }
      rail.appendChild(k);
    });
    reco.hidden = !rcards.length;
  }

  root.querySelectorAll('[data-ccm-tabs]').forEach(function (tabs) {
    var btns = [].slice.call(tabs.querySelectorAll('.ccm-tab'));
    var panes = [].slice.call(tabs.querySelectorAll('.ccm-pane'));

    // « Meilleures ventes » : les produits des autres onglets, classés par commandes sur 7 jours.
    panes.forEach(function (pane) {
      var max = +pane.dataset.best;
      if (!max) return;
      var seen = {}, cards = [];
      tabs.querySelectorAll('.ccm-pane:not([data-best]) .ccm-card').forEach(function (c) {
        if (seen[c.dataset.pid]) return;
        seen[c.dataset.pid] = 1; cards.push(c);
      });
      cards.sort(function (a, b) { return (+b.dataset.s || 0) - (+a.dataset.s || 0); });
      var grid = pane.querySelector('.ccm-grid');
      cards.slice(0, max).forEach(function (c) { grid.appendChild(c.cloneNode(true)); });
    });

    btns.forEach(function (b) {
      var pane = tabs.querySelector('.ccm-pane[data-pane="' + b.dataset.tab + '"]');
      var n = pane.querySelectorAll('.ccm-card').length;
      if (!n) { b.hidden = true; return; }
      b.querySelector('.ccm-tab-n').textContent = n;
      var img = pane.querySelector('.ccm-card-img img');
      if (img) b.querySelector('.ccm-tab-img').appendChild(img.cloneNode(true));
      function pick() {
        btns.forEach(function (x) { x.classList.toggle('is-on', x === b); });
        panes.forEach(function (p) { p.classList.toggle('is-on', p === pane); });
      }
      b.addEventListener('mouseenter', function () { if (desk.matches) pick(); });
      b.addEventListener('click', function () {
        pick();
        if (!desk.matches) { pane.scrollTop = 0; pane.classList.add('is-m'); }
      });
    });
  });

  /* ---------- pastille du panier ---------- */
  var countEl = root.querySelector('.ccm-count');
  function refreshCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var n = c.items.reduce(function (a, i) {
        return (i.variant_id === 49059516973383 || i.handle === 'navidium-shipping-protection') ? a : a + i.quantity;
      }, 0);
      countEl.textContent = n;
      countEl.hidden = !n;
    }).catch(function () {});
  }
  var nativeFetch = window.fetch;
  window.fetch = function (input) {
    var url = String(typeof input === 'string' ? input : (input && input.url) || '');
    var p = nativeFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(function () { setTimeout(refreshCount, 300); });
    return p;
  };

  /* ---------- bandeau Commande express : fermeture 1 jour, le bandeau se replie puis fonce vers l'éclair ---------- */
  var xb = root.querySelector('[data-ccm-xb]'), xbClose = root.querySelector('[data-ccm-xb-close]');
  if (xb && xbClose) xbClose.addEventListener('click', function () {
    var bolt = root.querySelector('.ccm-express'), html = document.documentElement;
    try { localStorage.setItem('ccm-xb-off', String(Date.now())); } catch (e) {}
    T('menu', 'bandeau_express_fermer', 'Commande express', { chemin: location.pathname });
    function done() { html.classList.add('ccm-xb-off'); }
    if (!bolt || !xb.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return done();
    var br = xb.getBoundingClientRect(), ir = bolt.getBoundingClientRect();
    var a = xb.querySelector('.ccm-xb-a'), boltSvg = bolt.querySelector('svg');
    var g = document.createElement('div');
    g.className = 'ccm-xb-ghost';
    g.innerHTML = '<span class="g-t">' + (a ? a.querySelector('.ccm-xb-t').innerHTML : '') + '</span>' + (boltSvg ? boltSvg.outerHTML.replace('<svg', '<svg class="g-b"') : '');
    g.style.cssText = 'left:' + br.left + 'px;top:' + br.top + 'px;width:' + br.width + 'px;height:' + br.height + 'px';
    document.body.appendChild(g);
    xb.style.visibility = 'hidden';
    var pw = 96, ph = 26, px = br.left + (br.width - pw) / 2, py = br.top + (br.height - ph) / 2;
    var d = 24, tx = ir.left + (ir.width - d) / 2, ty = ir.top + (ir.height - d) / 2;
    var gt = g.querySelector('.g-t'), gb = g.querySelector('.g-b');
    if (gt) gt.animate([{ opacity: 1, transform: 'scale(1)' }, { opacity: 0, transform: 'scale(.85)' }], { duration: 160, fill: 'forwards' });
    if (gb) gb.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 140, delay: 120, fill: 'forwards' });
    xb.animate([{ height: br.height + 'px' }, { height: '0px' }], { duration: 300, delay: 60, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'forwards' });
    g.animate([
      { left: br.left + 'px', top: br.top + 'px', width: br.width + 'px', height: br.height + 'px', borderRadius: '0px' },
      { left: px + 'px', top: py + 'px', width: pw + 'px', height: ph + 'px', borderRadius: '14px', offset: .55 },
      { left: (br.left + br.width / 2 - ph / 2) + 'px', top: py + 'px', width: ph + 'px', height: ph + 'px', borderRadius: '14px' }
    ], { duration: 280, easing: 'cubic-bezier(.65,0,.35,1)', fill: 'forwards' }).onfinish = function () {
      g.animate([
        { left: (br.left + br.width / 2 - ph / 2) + 'px', top: py + 'px', width: ph + 'px', height: ph + 'px', transform: 'scale(1)' },
        { left: (br.left + br.width / 2 - ph / 2) + 'px', top: (py + 6) + 'px', width: ph + 'px', height: ph + 'px', transform: 'scale(1.06)', offset: .12 },
        { left: tx + 'px', top: ty + 'px', width: d + 'px', height: d + 'px', transform: 'scale(.8)' }
      ], { duration: 780, easing: 'cubic-bezier(.45,0,.3,1)', fill: 'forwards' }).onfinish = function () {
        g.remove();
        xb.style.visibility = '';
        done();
      };
    };
  });

  /* ---------- en-tête masqué en descendant, visible en remontant ---------- */
  var lastY = window.scrollY, ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = window.scrollY;
      var hide = y > lastY && y > 160 && !current() && !document.documentElement.classList.contains('ccm-open');
      section.classList.toggle('ccm-hide', hide);
      lastY = y; ticking = false;
    });
  }, { passive: true });
})();
